var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.306522 7.73123L5.10652 2.82689C5.38043 2.54645 5.66087 2.41602 6 2.41602C6.34565 2.42254 6.62609 2.54645 6.9 2.82689L11.6935 7.73775C11.9022 7.93993 12 8.18775 12 8.48775C12 9.08775 11.5109 9.58341 10.9174 9.58341C10.6239 9.58341 10.3435 9.46601 10.1217 9.23123L6.01304 4.97254L1.88478 9.23123C1.66304 9.45949 1.38913 9.58341 1.08261 9.58341C0.48913 9.58341 0 9.08775 0 8.48775C0 8.19428 0.104348 7.94645 0.306522 7.73123Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/Icon_Left.da6f9b265c2e05df0143ed67e595c207.svg";
export { ForwardRef as ReactComponent };